// src/modules/renters/components/negotiation-debits/form/FormNegotiationDebits.tsx
import { useState } from 'react';
import { FormikProvider } from 'formik';
import { PaymentFormikRenter } from '@/modules/loan/components/form/fields/TableRenterPayments';
import { PaymentInfo } from '@/types/payment.type';
import { IRenter } from '@/types/renter.type';
import ButtonWithLoader from '@/common/components/ui/loading/ButtonLoading';
import { usePaymentsData } from '../customhook/usePaymentsData';
import { useDebitsNegotiationForm } from '../customhook/useDebitsNegotiationForm';
import { DebitsInfoSection } from '../components/informations/DebitsInfoSection';
import { ForgivenessInfoSection } from '../components/ForgivenessInfoSection';
import { TotalValueSection } from '../components/TotalValueSection';
import { PaymentOptionsSection } from '../components/payments/PaymentOptionsSection';

type PropsDebits = {
  renter: IRenter;
  payments: PaymentInfo[];
};

export function FormDebitsNegotiation(props: PropsDebits) {
  const [enableManualEdit, setEnableManualEdit] = useState(false);
  const { validPayments } = usePaymentsData(props.payments);

  const { formik, amountCharged, finalValue } = useDebitsNegotiationForm({
    renter: props.renter,
    payments: props.payments,
    enableManualEdit
  });

  return (
    <form onSubmit={formik.handleSubmit} className="p-6 bg-white rounded-lg shadow space-y-6">
      <FormikProvider value={formik}>
        <div className="space-y-6">
          <DebitsInfoSection />

          <section id="payments-section">
            <PaymentFormikRenter
              key={props.renter._id!}
              payments={validPayments}
            />
          </section>

          <ForgivenessInfoSection />

          <TotalValueSection
            totalValue={formik.values.paymentInfo.totalValue}
            enableManualEdit={enableManualEdit}
            onEnableEditChange={setEnableManualEdit}
          />
          <PaymentOptionsSection
            baseValue={formik.values.paymentInfo.totalValueEdited || formik.values.paymentInfo.totalValue} // ✅ Usar baseValue correto
            amountCharged={amountCharged}
            finalValue={finalValue}
          />
        </div>
      </FormikProvider>

      <div className="mt-2 w-full flex justify-end">
        <ButtonWithLoader
          isLoading={formik.isSubmitting}
          onClick={() => formik.submitForm()}
          disabled={formik.isSubmitting}
        >
          Salvar
        </ButtonWithLoader>
      </div>
    </form>
  );
}